import React from 'react';

import { useNavigate } from 'react-router-dom';
import CustomContainer from '../../../components/CustomContainer';
import FunctionalTableComponent from '../../../components/table/FunctionalTableComponent';
import columns from './ReservationTableConfig';
import { Button, Col } from 'react-bootstrap';
import LightButton from '../../../components/button/LightButton';

const ReservationTablePage = () => {
  const navigate = useNavigate();

  return (
    <>
      <CustomContainer title={'Rezerwacje'}>
          <FunctionalTableComponent
            shadow={false}
            title={'Lista rezerwacji'}
            columns={columns}
            header={true}
            api={'reservation'}
            removable={false}
            editable={false}
            details={true}
            detailsAction={(id) => navigate('/reservation/' + id)}
            width={12}
          />
      </CustomContainer>
    </>
  );
};

export default ReservationTablePage;
